import React from "react";
import { RefreshCw } from "lucide-react";

/**
 * Tlačítko Obnovit, vynutí re-fetch dat z backendu (?force=1).
 * Používá `refetch` a `refreshing` z useApiData hooku.
 *
 * Props:
 *  - refetch: () => void
 *  - refreshing: boolean
 *  - className?: string (volitelné, pro pozici)
 */
export default function RefreshButton({ refetch, refreshing, className = "" }) {
  return (
    <button
      onClick={refetch}
      disabled={refreshing}
      title="Vynutit aktualizaci dat (obejde cache)"
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-sm font-medium transition-colors ${
        refreshing
          ? "bg-slate-200 text-slate-400 cursor-wait"
          : "bg-slate-100 text-slate-600 hover:bg-slate-200"
      } ${className}`}
    >
      <RefreshCw className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`} />
      {refreshing ? "Načítám…" : "Obnovit"}
    </button>
  );
}
